export async function getList({ /*token,*/ uid, prjId, targetDt }) {
    const url = 'https://reports.imon.gulfnet-cloud.com/v1/checks';
    const params = { /*token: token,*/ uid: uid, prjId:prjId, targetDt: targetDt.toISOString() };
    const query_params = new URLSearchParams(params);
    const init_params = {
        credentials: "same-origin"
    }
    const res = await fetch(url + '?' + query_params, init_params);
    //const results = JSON.parse(await res.json());
    const results = res.json();
    
    let checksData = {siteCheckIds:[],batchCheckIds:[],maintCheckIds:[],checks:{}};
    //checksData['targetDt'] = Date.parse(results.targetDt);  // ToDo: parse check
    checksData['fromDt'] = Date.parse(results.fromDt);  // ToDo: parse check
    checksData['toDt'] = Date.parse(results.toDt);  // ToDo: parse check
    // for (const check of results.checks) {
    //     checksData.checks[check.id] = check;
    //     switch (check.type) {
    //         case 'site':
    //             siteCheckIds.push(check.id);
    //             break;
    //         case 'batch':
    //             batchCheckIds.push(check.id);
    //             break;
    //         case 'maint':
    //             maintCheckIds.push(check.id);
    //             break;
    //     }
    //     checksData.ids.push(check.id);
    // }
    for (const check of results.site_check) {
        checksData.siteCheckIds.push(check.id);
        checksData.checks[check.id] = check
    }
    for (const check of results.batch_check) {
        checksData.batchCheckIds.push(check.id);
        checksData.checks[check.id] = check
    }
    for (const check of results.maint_check) {
        checksData.maintCheckIds.push(check.id);
        checksData.checks[check.id] = check
    }
    return checksData;
}
